(function () {
  if (window.__cartTitleCountInit) return;
  window.__cartTitleCountInit = true;

  function getCounterEl() {
    return document.querySelector('[data-cart-count]');
  }

  function computeSum() {
    const container = document.querySelector('#main-cart-items');
    if (!container) return 0;
    const inputs = container.querySelectorAll('input.quantity__input');
    let sum = 0;
    inputs.forEach((i) => {
      const v = parseInt(i.value, 10);
      if (!isNaN(v)) sum += v;
    });
    return sum;
  }

  function updateCount() {
    const el = getCounterEl();
    if (!el) return;
    const sum = computeSum();
    const singular = el.dataset.singular || 'artículo';
    const plural = el.dataset.plural || 'artículos';
    const label = sum === 1 ? singular : plural;
    el.textContent = `(${sum} ${label})`;
  }

  function setupObserver() {
    const target = document.querySelector('#main-cart-items');
    if (!target || target.__cartTitleCountObserver) return;
    const mo = new MutationObserver(() => requestAnimationFrame(updateCount));
    mo.observe(target, { childList: true, subtree: true });
    target.__cartTitleCountObserver = mo;
  }

  function init() {
    updateCount();
    setupObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Soporte en el editor del tema (cuando se recargan secciones)
  document.addEventListener('shopify:section:load', init);
})();
